import React from 'react';
import { motion } from 'framer-motion';

export const GlassCard = ({ children, className = '', hoverEffect = true }) => {
  return (
    <motion.div
      whileHover={hoverEffect ? { 
        y: -6,
        boxShadow: "0 12px 28px rgba(139, 92, 246, 0.12), 0 0 20px rgba(139, 92, 246, 0.15)",
        borderColor: "rgba(139, 92, 246, 0.4)"
      } : {}}
      className={`glass-card ${className} ${hoverEffect ? 'hoverable' : ''}`}
      style={{
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
        transform: 'translateZ(0)'
      }}
    >
      <div className="glass-card-glow" />
      <div className="glass-card-content">
        {children}
      </div>
    </motion.div>
  );
};

export default GlassCard;